module.exports = __webpack_public_path__ + "static/media/board_review.727e7692.png";